module.exports = __webpack_public_path__ + "static/media/linkedin.a76f4966.svg";